export default String.raw`
const ComparerPopupUI = (() => {
    'use strict';
    const popupContainer = document.querySelector('.popup-js');

    if (!popupContainer) {
        return;
    }

    window.addEventListener('comparer:added', async () => {
        try {
            const response = await $.get(__ComparerLink, {
                __template: 'partials/product/comparison/add-to-compare-popup.html',
                __collection: 'comparison-tool'
            });
    
            if(!response || !response.template) {
                return;
            }
    
            popupContainer.innerHTML = response.template;
            popupContainer.querySelector('dialog')?.showModal();
        } catch (error) {
            console.error('Failed to load comparer popup.', error);
        }
    });
})();
`